import { render, staticRenderFns } from "./FileUploaderImg.vue?vue&type=template&id=3cf2f7e8&scoped=true"
import script from "./FileUploaderImg.vue?vue&type=script&lang=js"
export * from "./FileUploaderImg.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderImg.vue?vue&type=style&index=0&id=3cf2f7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2f7e8",
  null
  
)

export default component.exports